export const envMODE =
  process.env.NEXT_PUBLIC_VERCEL_ENV == 'development' ? 'DEV' : 'PROD'
